import { createRouter } from "@tanstack/react-router";

import { routeTree } from "./routeTree.gen";

export const router = createRouter({
  routeTree,
  context: {
    auth: undefined!,
    user: undefined!,
    organization: undefined!,
    locations: undefined!,
    queryClient: undefined!,
    ability: undefined!,
  },
  defaultPreload: "intent",
  defaultPendingMinMs: 0,
  defaultStructuralSharing: true,
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
